export default __webpack_public_path__ + "static/media/art-brw-poster-3.94e7ec35.jpg";